import { render } from "./Back.vue?vue&type=template&id=fc8effca&scoped=true&ts=true"
import script from "./Back.vue?vue&type=script&lang=ts"
export * from "./Back.vue?vue&type=script&lang=ts"

import "./Back.vue?vue&type=style&index=0&id=fc8effca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8effca"]])

export default __exports__